export default  {
    spinner: "pump", // pump, accordion, pulsar, cube, cubes, circle-line, circles, cube-grid
    image: false,
    fontawesome: false, // "fa fa-refresh fa-spin fa-2x fa-fw"
    custom: false, // jQuery Object
    color: "#fff",
    background: "rgba(0, 0, 0, 0.21)",
    maxSize: "50px", // Integer/String only for spinners & images, not fontawesome & custom
    minSize: "20px", // Integer/String only for spinners & images, not fontawesome & custom
    text: false,
    textColor: false, // default is color
    textMargin: ".5rem", 
    textPosition: "right", // left, right, top, bottom  
    fontSize: "1rem",
    fullScreen: false, 
    animation: false,	// fade, slide
    animationDuration: "fast",	// String, Integer 
    containerClass: "busy-load-container", 
    containerItemClass: "busy-load-container-item", 
    spinnerClass: "busy-load-spinner", 
    textClass: "busy-load-text",  
};


// WEBPACK FOOTER //
// ./node_modules/busy-load/src/lib/defaults.js